import { Navigate } from "react-router-dom";

const ProtectedRoute = ({ children }) => {
  const token = localStorage.getItem("token");
  const kinkeeperID = localStorage.getItem("kinkeeperID");

  if (!token || !kinkeeperID) {
    return <Navigate to="/relativeLogin" replace />;
  }

  return children;
};

export default ProtectedRoute;
